import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { isMobileView, isMobileDevice, isIOSiPhoneDevice, resumeScrolling } from 'src/utils/util';
import {
    getConfigurations,
} from 'src/common/redux/actions';
import { setPageLoader } from '../redux/action/actionCreators';

export function useReportUsageMountEffect({
  setFilteredProduct,
  dispatch,
  resetReportUsageData,
  clearSingleDropDownList,
  resetNotes,
  resetSurgeryDetails,
  resetValidateAccountDetails,
  resetReportUsageStates,
  MENU,
  unlockOrderFunc,
  myCaseRefId,
  myCaseResourceType,
}) {
  useEffectWithErrorLogging(() => {
    let body = document.getElementById('body');
    const htmlElement = document.getElementsByTagName('html');
    if (isMobileView()) {
      body.style.backgroundColor = '#140f4b';
    }
    const firstHtmlElement = htmlElement && htmlElement?.[0];
    if (isIOSiPhoneDevice() && firstHtmlElement) {
      firstHtmlElement.style.height = '100vh';
    }

    const handleOrientationChange = () => {
      const isLandscape = window.innerWidth > window.innerHeight;
      if (isMobileDevice() && isLandscape) {
        body.style.backgroundColor = '';
      }
    };
    window.addEventListener('resize', handleOrientationChange);

    return () => {
      window.removeEventListener('resize', handleOrientationChange);
      dispatch(setPageLoader(false)); // Stop loading
      setFilteredProduct([]);
      dispatch(resetReportUsageStates());
      dispatch(getConfigurations({ resourceType: 'PROCESS' }, MENU));
      resetReportUsageData();
      dispatch(resetNotes());
      dispatch(resetSurgeryDetails());
      dispatch(resetValidateAccountDetails());
      dispatch(clearSingleDropDownList({ name: 'physicianList' }));
      (myCaseRefId && myCaseRefId?.length > 0) && unlockOrderFunc({
        action:
          myCaseResourceType === 'reportPayment'
            ? 'ReportPayment'
            : myCaseResourceType === 'draft'
            ? 'DraftUsageEdit'
            : 'ReportUsage',
        myCaseRefId: myCaseRefId,
      });
      body.style.backgroundColor = '';
      const firstHtmlElementOnCleanup = htmlElement && htmlElement?.[0];
      if (isIOSiPhoneDevice() && firstHtmlElementOnCleanup) {
        firstHtmlElementOnCleanup.style.height = '';
      }
      resumeScrolling();
    };
  }, []);
}